import styled from '@emotion/styled';
import {IconFilter, IconList, IconMap, IconSort} from '@travel-frontend/icons';
import {
  Button,
  LabelSmall,
  LabelXSmall,
  Stack,
} from '@travel-frontend/ui-components';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Divider} from '@/components/Divider';
import {useSortingOptions} from '@/modules/common/components/SortingDropdown/useSortingOptions';
import {useFilterOverlay} from '@/modules/common/context/FilterOverlay';
import {useSortParams} from '@/modules/common/hooks/useSortParams';
import {DropDown} from '@/modules/hotels/components/List/components/DropDown/DropDown';
import {Container} from '@/modules/hotels/components/List/components/TabRow/components/Container';
import {SortButton} from '@/modules/hotels/components/List/components/TabRow/components/SortButton';

type Props = {
  mapView: boolean;
  openMapView: () => void;
  closeMapView: () => void;
};

const scrollToTop = () => {
  window.scrollTo({top: 0, behavior: 'smooth'});
};

export const TabRow = styled(
  ({mapView, openMapView, closeMapView, ...restProps}: Props) => {
    const {t} = useTranslation(['general', 'hotels']);
    const {toggleFilterOverlay} = useFilterOverlay();

    const [sortParams, setSortParams] = useSortParams();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const options = useSortingOptions();

    const activeOption = options.find(
      (option) => option.value === sortParams.sortBy
    );

    const handleOnChange = (option: any) => {
      setSortParams((previous) => ({
        ...previous,
        sortBy: option.value,
      }));
      setIsOpen(!isOpen);
      scrollToTop();
    };
    return (
      <>
        <Container direction="row" mapView={mapView} {...restProps}>
          <Button
            category="tertiary"
            onClick={mapView ? closeMapView : openMapView}
          >
            {mapView ? <IconList /> : <IconMap />}
            <LabelSmall>
              {mapView
                ? t('hotels:mapView.tabRowHotelsButton.label')
                : t('hotels:mapView.tabRowMapButton.label')}
            </LabelSmall>
          </Button>
          <Divider category="secondary" orientation="vertical" />
          {!mapView && (
            <SortButton category="tertiary" onClick={() => setIsOpen(!isOpen)}>
              <IconSort />
              <Stack gap={0}>
                <LabelSmall>{t('general:sortingDropdown.label')}</LabelSmall>
                <LabelXSmall truncate color="contentSecondary">
                  {activeOption?.label}
                </LabelXSmall>
              </Stack>
            </SortButton>
          )}
          {!mapView && <Divider category="secondary" orientation="vertical" />}
          <Button category="tertiary" onClick={toggleFilterOverlay}>
            <IconFilter />
            <LabelSmall>{t('general:buttons.filter')}</LabelSmall>
          </Button>
        </Container>
        {isOpen && (
          <DropDown
            selectedValue={sortParams.sortBy}
            options={options}
            handleChange={handleOnChange}
          />
        )}
      </>
    );
  }
)``;
